import React, { useState } from "react"
import { Autocomplete, TextField } from "@mui/material"
import { availableReports } from "routes/sfg20-admin/plugins/system-info/reports-tab/available-reports"

export function ReportSelector({ setReport }) {
    const [selectedReport, setSelectedReport] = useState(null)

    const handleChange = (_, newValue) => {
        setSelectedReport(newValue)
        setReport(newValue ? newValue.id : "")
    }

    return (
        <Autocomplete
            options={availableReports}
            getOptionLabel={(report) => report.title}
            value={selectedReport}
            onChange={handleChange}
            filterOptions={(options, state) => {
                if (!state.inputValue) {
                    return options // show all options if nothing is typed
                }
                return options.filter((option) => option.title.toLowerCase().includes(state.inputValue.toLowerCase()))
            }}
            renderInput={(params) => <TextField {...params} label="Select Report" variant="standard" fullWidth />}
        />
    )
}
